<template>
  <div class="gatilhos-page">
    <AcaoObjetoList
      endpoint-base="/admin/gatilhos"
      modal-name="gatilhoEdit"
      :entidades-excluir="['sac']"
    />
  </div>
</template>

<script>
import AcaoObjetoList from '@/components/AcaoObjeto/AcaoObjetoList.vue';

export default {
  name: 'gatilhos',
  components: { AcaoObjetoList },
};
</script>

<style scoped>
.gatilhos-page {
  padding-bottom: 24px;
}
</style>
